import {$timeout} from 'ng'
import webfonts from 'webfonts/webfonts'

function WebFontsDirective($timeout) {
    return {
        scope: {
            fontLoaded: '=?',
            family: '=?',
            onLoad: '&',
            font: '@font'
        },
        link(scope, element, attrs) {
            scope.$watch('font', font => element.css('fontFamily', font));
            $timeout(function () {
                webfonts.load(scope.font, element.text()).then(() => {
                    element.css('fontFamily', scope.font);
                });
            }, 100);
        },
        restrict: "AE"
    };
};

export default WebFontsDirective;